export default __webpack_public_path__ + "static/media/guest.4dd71a6a.svg";